import { AnalyticsPlugin, TrackerSharedConfigurations } from '@pulse/common';
import { PluginHost } from '../plugin';

export class PluginsFactory {
    constructor(
        private config: TrackerSharedConfigurations,
        private pluginHost: PluginHost,
    ) {}

    registerPlugins() {
        const plugins: AnalyticsPlugin[] = [...(this.config.plugins || [])];

        plugins.forEach((plugin) => this.pluginHost.register(plugin));
    }
}
